import iconRadioNormal from '@/assets/img/radio_normal.png';
import iconRadioActive from '@/assets/img/radio_active.png';
import iconRadioDisabled from '@/assets/img/radio_disabled.png';


const Radio = ({
  children,
  className,
  style,
  currentValue,
  value,
  onClick,
  item,
  imgDisabled
}) => {
  return (
    <span onClick={onClick} className={`${className} cursor-pointer`} style={style}>
      <img
        className="w-16px mr-12px"
        src={currentValue == value ? iconRadioActive : ((imgDisabled && !item.support_mcp) ? iconRadioDisabled :  iconRadioNormal)}
      />
      {children}
    </span>
  );
};

export default Radio;
